import { Component, Input, OnInit, forwardRef, Inject } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';
import { UIRouter }                 from '@uirouter/core';

import { GroupModel }         from './typings/group-rights.group';
import { GroupRightModel }    from './typings/group-right';
import { GroupRightsService } from './group-rights.service';
import { MessagesService }    from '../messages/messages.service';
import { SessionService }     from '../sessions/session.service';

@Component({
  selector   : 'wor-group-rights',
  styles: [ require('./group-rights.component.scss') ],
  template: require('./group-rights.component.html')
})
export class GroupRightsComponent implements OnInit {
  @Input() group : GroupModel;
  @Input() groups: Array<GroupModel>;
  @Input() rights: Array<GroupRightModel>;

  allSelected = false;

  constructor (
    @Inject(forwardRef(() => GroupRightsService)) private groupsService   : GroupRightsService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    private router          : UIRouter,
    @Inject(forwardRef(() => SessionService))
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.group.group_rights_attributes.forEach(( attribute : GroupRightModel ) => {
      const match = this.rights.find(( right : GroupRightModel ) => right.object_name === attribute.object_name);

      if ( match ) {
        match.allow = true;
      }
    });

    this.allSelected = this.areAllSelected();
  }

  areAllSelected () : boolean {
    return this.group.group_rights_attributes.length < this.rights.length
      ? false
      : this.rights.find(( right : GroupRightModel ) => right.allow === false)
        ? false
        : true;
  }

  delete () : void {
    this.groupsService.delete(this.group)
    .then(() => {
      this.router.stateService.go('app.group-rights-groups');

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.GROUP'), 'success');
    })
    .catch(error => this.messagesService.error(error));
  }

  handleGroupSelection () : void {
    this.router.stateService.go('app.group-rights', {
      group_name: this.group.group_name
    });
  }

  handleRightChange ( right : GroupRightModel ) : void {
    const selectedRights = this.group.group_rights_attributes;

    let found = false;

    for ( let i = 0; i < selectedRights.length; i++ ) {
      if ( right.object_name === selectedRights[ i ].object_name ) {
        selectedRights[ i ]._destroy = right.allow
          ? '0'
          : '1';

        found = true;
        break
      }
    }

    if ( !found && right.allow ) {
      this.group.group_rights_attributes.push({
        access     : '',
        id         : '',
        object_name: right.object_name,
        title      : '',
        _destroy   : '0'
      });
    }

    this.allSelected = this.areAllSelected();
  }

  save ( form : NgForm ) : void {
    this.groupsService.update(this.group)
    .then(() => this.sessionService.refresh)
    .then(() => {
      this.router.stateService.go('app.group-rights-groups');

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.GROUP'), 'success');
    })
    .catch(error => this.messagesService.error(error));
  }

  select ( select = 'all' ) : void {
    this.rights.forEach(( right : GroupRightModel ) => {
      right.allow = select === 'all';

      this.handleRightChange(right);
    });
  }
}
